// src/pages/Dashboard.jsx
import React, { Component } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TopBar from './components/TopBar';
import Footer from './components/Footer';

import LiveReadPage from './dashboard/LiveReadPage';
import DecoratePage from './dashboard/DecoratePage';
import ProjectPage from './dashboard/ProjectPage';
import ChapterPage from './dashboard/ChapterPage';
import SocialMediaPage from './dashboard/SocialMediaPage';
import Menu from './dashboard/Menu';
import MenuToggleButton from './dashboard/menu/MenuToggleButton';

import { withRouter } from './navigation/withNavigation';
import PublishPage from './dashboard/PublishPage';
import EditPage from './dashboard/EditPage';
import { AppContext } from '../context/AppContext';
import { NotificationProvider } from '../state/notifications/NotificationContext';

const NotificationsPage = () => <div style={{padding:16}}>Notifications (coming soon)</div>;

class Dashboard extends Component {
  static contextType = AppContext;

  state = { menuOpen: false };

  getActiveTabFromPath(pathname) {
    if (pathname.includes('/project/') && (pathname.includes('/library') || pathname.includes('/chapter/'))) return 'Editor';
    if (pathname.includes('/project/') && pathname.includes('/live-read')) return 'Reader';
    if (pathname.includes('/project/') && pathname.includes('/decorate')) return 'Decorator';
    if (pathname.includes('/project/') && pathname.includes('/publish')) return 'Publisher';
    if (pathname.includes('/project/') && pathname.includes('/social-media')) return 'Social Media';
    if (pathname.includes('/project/') && pathname.includes('/edit')) return 'Website Builder';
    return 'Editor';
  }

  handleTabChange = (tab) => {
    const pid = this.props.params?.projectId;
    if (!pid) return this.props.navigate('/');
    const routes = {
      'Editor': `/project/${pid}/library`,
      'Reader': `/project/${pid}/live-read`,
      'Decorator': `/project/${pid}/decorate`,
      'Publisher': `/project/${pid}/publish`,
      'Social Media': `/project/${pid}/social-media`,
      'Website Builder': `/project/${pid}/edit`,
    };
    this.props.navigate(routes[tab] || `/project/${pid}/library`);
  };

  toggleMenu = () => this.setState((s) => ({ menuOpen: !s.menuOpen }));
  closeMenu = () => this.setState({ menuOpen: false });

  render() {
    const { location } = this.props;
    const { menuOpen } = this.state;
    const isWriterMode = !!this.context?.state?.isWriterMode;
    const activeTab = this.getActiveTabFromPath(location.pathname);
    const isProjectLibraryPage = /^\/project\/[^/]+\/library\/?$/.test(location.pathname || '');

    return (
      <NotificationProvider>
        <div className={`dashboard${isWriterMode ? ' dashboard--writer-mode' : ''}`}>
          {!isWriterMode && <TopBar />}

          {!isWriterMode && (
            <MenuToggleButton
              open={menuOpen}
              onToggle={this.toggleMenu}
              className="menu-toggle-fixed"
            />
          )}

          <div className="app-body">
            {!isWriterMode && (
              <Menu
                activeTab={activeTab}
                onTabChange={this.handleTabChange}
                open={menuOpen}
                onClose={this.closeMenu}
                className={isProjectLibraryPage ? 'menu--project-page' : ''}
              />
            )}

            <div className="content">
              <div className={`content-main editor-left${isWriterMode ? ' writer-mode' : ''}`}>
                <Routes>
                  <Route index element={<Navigate to="library" replace />} />
                  <Route path="library" element={<ProjectPage />} />
                  
                  <Route path="live-read" element={<LiveReadPage />} />
                  <Route path="decorate" element={<DecoratePage />} />
                  <Route path="decorate/:id" element={<DecoratePage />} />
                  <Route path="notifications" element={<NotificationsPage />} />
                  <Route path="publish" element={<PublishPage />} />
                  <Route path="edit" element={<EditPage />} />
                  <Route path="social-media" element={<SocialMediaPage />} />
                  <Route path="chapter/:chapterId" element={<ChapterPage />} />
                  <Route path="library/chapter/:chapterId" element={<ChapterPage />} />
                  <Route path="*" element={<Navigate to="library" replace />} />
                </Routes>
              </div>
            </div>
          </div>

          {!isWriterMode && <Footer />}
        </div>
      </NotificationProvider>
    );
  }
}

export default withRouter(Dashboard);
